import { useAdminData } from "@providers/AdminDataProvider";

export const useIsAdmin = () => {
  const { roles } = useAdminData();
  return roles.includes("admin");
};
